import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { fetchTelecallerCallbacklist, fetchTelecallerPTPlist } from "../../store/telecaller/cases";
import ReusableTable from "../../Reuseable/ReusableTable/ReusableTable";
import { ReactComponent as Calender } from "../../assets/Icons/calendarIcon.svg";
import { Button, DatePicker, Skeleton, Tooltip } from "antd";
import { formatCurrency } from "../../assets/helpers";
import './style.scss'
import { CasesFeedbackModal } from "../AllocationComp/FeedbackModal/CasesFeedback";
import moment from "moment";

const CallBackList = () => {
    const [date, setDate] = useState(null);
    const dispatch = useDispatch();
    const { callback_list, callback_list_loading } = useSelector((state) => state.telecallerCases);
    const { format } = useSelector(state => state.priceFormat);
    const [openFeedbackModal, setOpenFeedbackModal] = useState(false);
    const [selectedCase, setSelectedCase] = useState(null);
    const [refresh, setRefresh] = useState(false);
    const [params, setParams] = useState({
        page: 1,
        page_size: 10,
    });
    useEffect(() => {
        dispatch(fetchTelecallerCallbacklist({ ...params }));
    }, [dispatch, params, refresh]);


    const columns = [
        {
            title: 'Customer Name',
            dataIndex: 'customer_name',
            key: 'customer_name',
            render: (text) =>
                callback_list_loading ? <Skeleton.Input size="small" active /> : text || "-",
        },
        {
            title: 'Loan No.',
            dataIndex: 'loan_no',
            key: 'loan_no',
            render: (text) =>
                callback_list_loading ? <Skeleton.Input size="small" active /> : text || "-",
        },
        {
            title: 'Phone Number',
            dataIndex: 'phone_number',
            key: 'phone_number',
            render: (text) =>
                callback_list_loading ? <Skeleton.Input size="small" active /> : text || "-",
        },
        {
            title: 'POS',
            dataIndex: 'odpos',
            key: 'odpos',
            render: (text) =>
                callback_list_loading ? <Skeleton.Input size="small" active /> : Number(text).toFixed(2) || "-",
        },

        {
            title: 'Amount Overdue',
            dataIndex: 'amount_overdue',
            key: 'amount_overdue',
            render: (text) =>
                callback_list_loading ? <Skeleton.Input size="small" active /> : formatCurrency(text, format) || "-",
        },
        {
            title: 'Bank',
            dataIndex: 'bank_name',
            key: 'bank_name',
            render: (text) =>
                callback_list_loading ? <Skeleton.Input size="small" active /> : text || "-",
        },

        {
            title: 'Feedback Date',
            dataIndex: 'date',
            key: 'date',
            render: (text) =>
                callback_list_loading ? <Skeleton.Input size="small" active /> : text || "-",
        },
        {
            title: 'Disposition',
            dataIndex: 'call_status',
            key: 'call_status',
            render: (text) =>
                callback_list_loading ? <Skeleton.Input size="small" active /> : text || "-",
        },
        {
            title: 'Callback Date & Time',
            dataIndex: 'callback_date_time',
            key: 'callback_date_time',
            render: (text) =>
                callback_list_loading ? <Skeleton.Input size="small" active /> : text ? moment(text).format("DD MMM, hh:mm A") : "-",
        },

        {
            title: 'Comment',
            dataIndex: 'comment',
            key: 'comment',
            render: (text) =>
                callback_list_loading ? <Skeleton.Input size="small" active /> : text?.length > 20 ? <Tooltip title={text}>
                    {text?.slice(0, 20) + '...'}
                </Tooltip> : text || "-",
        },
        {
            title: 'Action',
            dataIndex: 'action',
            key: 'action',
            render: (_, record) => <Button
                onClick={(e) => {
                    e.stopPropagation();
                      setOpenFeedbackModal(true);
                      setSelectedCase(record);
                }}
            >
                Feedback
            </Button>
        }
    ];

    const handleFeedbackSubmit = () => {
        setDate(null);
        setParams({ page: 1, page_size: 10 });
        setRefresh(prev => !prev);
    };


    return (
        <div className="ptp-list-container">
            <div className="date-picker-wrapper">
                <DatePicker
                    style={{ height: "43px" }}
                    placeholder="Select date & time"
                    className="form-date-picker"
                    suffixIcon={<Calender />}
                    // onChange={(dateStr, date) => setParams((prev) => ({ ...prev, date: date }))}
                    // //   showTime={{
                    // //     format: "HH:mm",
                    // //   }}
                    value={date}
                    onChange={(momentObj, dateString) => {
                        setDate(momentObj);
                        setParams((prev) => {
                            const newParams = { ...prev };
                            if (dateString) {
                                newParams.date = dateString;
                            } else {
                                delete newParams.date;
                            }
                            return newParams;
                        });
                    }}
                    format="YYYY-MM-DD"
                />
            </div>
            <ReusableTable
                columns={columns}
                dataSource={
                    callback_list_loading
                        ? Array(10).fill(0).map((_, i) => ({ id: `skeleton-${i}` }))
                        : callback_list?.results?.cases_with_feedback || []
                }
                totalItems={0}
                rowKey="id"
                // rowSelection={customRowSelection}
                // onRowClick={onRowClick}
                // pointer={pointer}
                CurrentPageNo={params?.page}
                pageSize={params?.page_size}
                triggerChange={(page, size) => {
                    setParams((prev) => ({ ...prev, page: page, page_size: size }));
                }}
            />
            <CasesFeedbackModal
                open={openFeedbackModal}
                setOpen={setOpenFeedbackModal}
                data={selectedCase}
                setRefresh={handleFeedbackSubmit}
            />
        </div>
    )
}
export default CallBackList;